var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { ref: "searchBox", staticClass: "search-box" },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入销售订单号" },
                model: {
                  value: _vm.condition.sn,
                  callback: function ($$v) {
                    _vm.$set(_vm.condition, "sn", $$v)
                  },
                  expression: "condition.sn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入SAP销售订单号" },
                model: {
                  value: _vm.condition.sapOrderSn,
                  callback: function ($$v) {
                    _vm.$set(_vm.condition, "sapOrderSn", $$v)
                  },
                  expression: "condition.sapOrderSn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择订单状态" },
                  model: {
                    value: _vm.condition.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "status", $$v)
                    },
                    expression: "condition.status",
                  },
                },
                _vm._l(_vm.statusOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.getPage("refresh")
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleEdit(null)
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "listTable",
          attrs: { data: _vm.tableData, height: _vm.tableHeight, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "订单状态",
              align: "left",
              prop: "status",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status == 1
                      ? _c("span", [_vm._v("制单")])
                      : _vm._e(),
                    scope.row.status == 2
                      ? _c("span", [_vm._v("审核中")])
                      : _vm._e(),
                    scope.row.status == 3
                      ? _c("span", [_vm._v("审核完成")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "单据类型",
              align: "left",
              prop: "salesName",
              "show-overflow-tooltip": "",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "销售订单号",
              align: "left",
              prop: "sn",
              "show-overflow-tooltip": "",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "SAP销售单号",
              align: "left",
              prop: "sapOrderSn",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "销售组织",
              align: "left",
              prop: "salesOrganizationName",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "售达方",
              align: "left",
              prop: "soldToPartyName",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "送达方",
              align: "left",
              prop: "deliverySideName",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "rdm接口状态",
              align: "left",
              prop: "sapPush",
              width: "130",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.sapPush == 1
                      ? _c("span", [_vm._v("成功")])
                      : _vm._e(),
                    scope.row.sapPush == 2
                      ? _c("span", [_vm._v("失败")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "接口信息",
              align: "left",
              prop: "message",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "备注",
              align: "left",
              prop: "note",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建人",
              align: "left",
              prop: "createUser",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              align: "left",
              prop: "createTime",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status <= 2
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row.id, "修改")
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row.id, "查看")
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.status === 3
                      ? _c(
                          "el-dropdown",
                          {
                            staticStyle: { margin: "0px 10px" },
                            attrs: { trigger: "click" },
                            on: { command: _vm.handleCommand },
                          },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 打印 "),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "flotsam," + scope.row.id,
                                    },
                                  },
                                  [_vm._v("废料")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "mountings," + scope.row.id,
                                    },
                                  },
                                  [_vm._v("配件")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.status <= 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    scope.row.status === 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "order:salesOrder:index:del",
                                expression: "'order:salesOrder:index:del'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "footer-box" },
        [
          _c("el-col", { attrs: { span: 12 } }),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.total,
                  page: _vm.pagination.current,
                  limit: _vm.pagination.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination, "size", $event)
                  },
                  pagination: _vm.getPage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("edit", {
        ref: "edit",
        attrs: { show: _vm.showEdit, "edit-id": _vm.editId },
        on: { close: _vm.closeEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }